import { render, staticRenderFns } from "./generalize.vue?vue&type=template&id=64ff1228&scoped=true"
import script from "./generalize.vue?vue&type=script&lang=js"
export * from "./generalize.vue?vue&type=script&lang=js"
import style0 from "./generalize.vue?vue&type=style&index=0&id=64ff1228&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64ff1228",
  null
  
)

export default component.exports